import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import NotificationContainer from "@/components/NotificationContainer.vue";
import { Notifications } from "@/store/NotificationStore";

@Component({
  components: {
    NotificationContainer
  }
})
export default class NotificationHandler extends Vue {
  private _timeout?: any;

  private _removeHeadNotification() {
    clearTimeout(this._timeout);
    this.$store.dispatch(
      "removeVisibleNotification",
      this.$store.getters.visible_notifications[0]
    );
  }

  mounted() {
    this.$store.subscribe((mutation: any, state: any) => {
      if (
        mutation.type == "SET_VISIBLE_NOTIFICATION" ||
        mutation.type == "REMOVE_VISIBLE_NOTIFICATION" ||
        mutation.type == "UPDATE_VISIBLE_NOTIFICATION"
      ) {
        clearTimeout(this._timeout);
        this.$forceUpdate();
      }
    });
  }

  private _generateNotification(
    headNotification: Notifications,
    content?: any,
    button?: any
  ) {
    let optionalIcon;

    if (
      headNotification.icon &&
      (!headNotification.loaderValue || headNotification.loaderValue >= 100)
    ) {
      optionalIcon = () => {
        return <v-icon>{headNotification.icon}</v-icon>;
      };
    } else {
      optionalIcon = () => {
        return (
          <v-progress-circular
            value={headNotification.loaderValue}
            rotate="270"
            size={45}
          >
            {headNotification.loaderValue}%
          </v-progress-circular>
        );
      };
    }

    return (
      <v-snackbar
        timeout={0}
        multi-line
        color={headNotification.type}
        bottom
        value={true}
      >
        <div style={{ marginRight: "8px" }}>
          {optionalIcon ? optionalIcon() : ""}
        </div>
        {content}
        <div style={{ marginLeft: "8px", paddingLeft: "0" }}>
          {button}
          <v-btn onclick={this._removeHeadNotification} text color={"white"}>
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </div>
      </v-snackbar>
    );
  }

  render(h: CreateElement) {
    if (
      !this.$store.getters.visible_notifications ||
      this.$store.getters.visible_notifications.length == 0
    )
      return;

    let customButton = () => {
      if (this.$store.getters.visible_notifications.length > 1) {
        return (
          <v-btn text onclick={this._removeHeadNotification}>
            NEXT ({this.$store.getters.visible_notifications.length - 1} more)
          </v-btn>
        );
      }
    };

    let headNotification: Notifications = this.$store.getters
      .visible_notifications[0];

    this._timeout = setTimeout(() => {
      if (headNotification.timeout > 0) {
        this._removeHeadNotification();
      }
    }, headNotification.timeout);

    return (
      <div>
        {this._generateNotification(
          headNotification,
          <span>{headNotification.value}</span>,
          customButton()
        )}
      </div>
    );
  }
}

const component = NotificationHandler;
